import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

// The banner an inactive order shows in place of Pay Now. An order replaced by a newer
// registration for the same course (orderMeta.supersededBy) says so and opens the new
// one; any other inactive order keeps the generic message.
function InactiveOrderNotice({ orgId, supersededBy }) {
  const navigate = useNavigate();

  return (
    <div
      className="w-full flex flex-col items-center gap-3 py-5 justify-center px-[19px] bg-[#FFF4E5] border-t-[1px] border-t-[#FFA726]"
    >
      <p className="text-[#E65100] font-semibold text-[16px] text-center">
        {supersededBy
          ? '⚠️ This order was replaced by a newer registration for the same course. Please pay on the new order.'
          : '⚠️ This order is inactive and cannot be processed. Please close this order and create a new one to continue.'}
      </p>
      {supersededBy && (
        <button
          type="button"
          onClick={() => navigate(`/${orgId}/orders/${supersededBy}`)}
          className="w-full md:w-1/2 lg:w-1/3 py-4 font-bold text-[16px] text-white rounded-[6px] bg-[#045692]"
        >
          Open the new order
        </button>
      )}
    </div>
  );
}

InactiveOrderNotice.propTypes = {
  orgId: PropTypes.string.isRequired,
  supersededBy: PropTypes.string,
};

InactiveOrderNotice.defaultProps = {
  supersededBy: null,
};

export default InactiveOrderNotice;
